"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapPageElement = exports.onClientEntry = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactHelmet = require("react-helmet");

var _interceptor = require("./utils/interceptor");

const wrapPageElement = ({
  element
}) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react.default.createElement("script", {
  type: "module"
}, `
          const pagefind = await import('/pagefind/pagefind.js');
          pagefind.init();
          globalThis.pagefind = pagefind;
        `)), element);

exports.wrapPageElement = wrapPageElement;

const onClientEntry = () => {
  if (typeof window !== 'undefined') {
    (0, _interceptor.interceptXMLHttpRequest)();
  }
};

exports.onClientEntry = onClientEntry;